var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRatingStarSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.96954L14.8326 8.61896C14.96 8.9179 15.2429 9.12125 15.5669 9.14661L22.9003 9.72062L17.3285 14.3806C17.0735 14.5939 16.962 14.9336 17.0409 15.2565L18.7458 22.235L12.4467 18.4785C12.1715 18.3144 11.8285 18.3144 11.5533 18.4785L5.25421 22.235L6.95915 15.2565C7.03805 14.9336 6.92648 14.5939 6.67146 14.3806L1.09971 9.72062L8.43311 9.14661C8.75705 9.12125 9.04003 8.9179 9.16738 8.61896L12 1.96954Z",
    fill: "#F44434",
    stroke: "#F44434",
    strokeWidth: 0.872093
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarSelected);
export default __webpack_public_path__ + "static/media/RatingStarSelected.5bb38093896d0e3de77baec78da72ad1.svg";
export { ForwardRef as ReactComponent };